const DEFAULTFORMAT = 'default_format';
const MEMOFORMAT = 'memo_format';
const PUBKEYFORMAT = 'pubkey_format';

export { DEFAULTFORMAT, MEMOFORMAT, PUBKEYFORMAT}